import script from "./ImageAnalysisView.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageAnalysisView.vue?vue&type=script&setup=true&lang=js"

import "./ImageAnalysisView.vue?vue&type=style&index=0&id=45bb2248&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45bb2248"]])

export default __exports__